import styled from 'styled-components'

export const InputPhoneStyle = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  div {
    display: flex;
    align-items: center;
  }

  p {
    margin: 0 5px 0 0;
    padding: 9px;
    background-color: ${({ theme }) => {
      return theme.colors.trueWhite
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small
    }};
    border: ${({ theme }) => {
      return theme.border
    }};
    border-color: ${({ theme }) =>
      ({ isValidate }: { isValidate: boolean }) => {
        if (isValidate) {
          return theme.colors.border
        } else {
          return theme.colors.error
        }
      }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    color: ${({ theme }) =>
      ({ isValidate }: { isValidate: boolean }) => {
        if (isValidate) {
          return theme.colors.primary
        } else {
          return theme.colors.error
        }
      }};
  }

  label {
    color: ${({ theme }) =>
      ({ isValidate }: { isValidate: boolean }) => {
        if (isValidate) {
          return theme.colors.primary
        } else {
          return theme.colors.error
        }
      }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.normal
    }};
    margin-bottom: 5px;
  }

  input {
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    padding: 10px;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small
    }};
    border: ${({ theme }) => {
      return theme.border
    }};
    border-color: ${({ theme }) =>
      ({ isValidate }: { isValidate: boolean }) => {
        if (isValidate) {
          return theme.colors.border
        } else {
          return theme.colors.error
        }
      }};
    font-family: 'Ubuntu', sans-serif;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    &::placeholder {
      color: ${({ theme }) =>
        ({ isValidate }: { isValidate: boolean }) => {
          if (isValidate) {
            return theme.colors.border
          } else {
            return theme.colors.error
          }
        }};
    }
  }

  @media screen and (max-width: 720px) {
    p {
      font-size: ${({ theme }) => {
        return theme.fonts.size.small
      }};
      padding: 5px;
    }
    label {
      font-size: ${({ theme }) => {
        return theme.fonts.size.small
      }};
      margin-bottom: 3px;
    }
    input {
      height: 30px;
      padding: 7px;
      font-size: ${({ theme }) => {
        return theme.fonts.size.small
      }};
    }
  }

  @media screen and (max-width: 480px) {
    p {
      font-size: ${({ theme }) => {
        return theme.fonts.size.superSmall
      }};
      padding: 7px;
    }
    label {
      font-size: ${({ theme }) => {
        return theme.fonts.size.superSmall
      }};
      margin-bottom: 1.5px;
    }
    input {
      font-size: ${({ theme }) => {
        return theme.fonts.size.superSmall
      }};
    }
  }
`
